import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../styles/App.css';
import styles from '../../styles/ManageAgency.module.css';
import InvitationForm from '../items/ManageAgency/InvitationForm';
import RemoveUserForm from '../items/ManageAgency/RemoveUserForm';
import { useManagerContext } from '../../contexts/ManagerContext';

const ManageAgency: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { userDetails, agencyDetails } = location.state || {};
    const [showInviteDialog, setShowInviteDialog] = useState(false);
    const [showRemoveUserDialog, setShowRemoveUserDialog] = useState(false);
    
    const { agencyUsers, sendUserInvitation, removeAgencyUsers, fetchAgencyUsersData } = useManagerContext();

    useEffect(() => {
        if (agencyDetails?.agencyId) {
            fetchAgencyUsersData(agencyDetails.agencyId);
        }
    }, [agencyDetails?.agencyId, fetchAgencyUsersData]);

    const handleInvite = async (email: string, role: string) => {
        setShowInviteDialog(false);
        
        const inviteData = {
            email,
            agencyId: agencyDetails?.agencyId || '',
            role,
            senderEmail: userDetails?.email || ''
        };

        try {
            await sendUserInvitation(inviteData);
            alert('Invitation sent successfully!');
        } catch (err) {
            alert('Failed to send invitation');
            console.error('Error sending invitation:', err);
        }
    };

    const handleRemoveUsers = async (userIds: string[]) => {
        try {
            await removeAgencyUsers(
                agencyDetails?.agencyId || '',
                userIds,
                userDetails?.id || ''
            );
            alert('User(s) removed successfully');
            // Refresh the user list
            if (agencyDetails?.agencyId) {
                fetchAgencyUsersData(agencyDetails.agencyId);
            }
        } catch (err) {
            alert('Failed to remove users');
            console.error('Error removing user(s):', err);
        }
    };

   useEffect(() => {
        if (!userDetails) {
            navigate('/LoginRegister', { replace: true });
        }
    }, [userDetails, navigate]);

    return (
        <div className={styles.agencyContainer}>
            <div>
                <h2>Manage Agency</h2>
                <p>{agencyDetails.companyName}: {agencyDetails.agencyDescription}</p>
                <p>Agency Role: {agencyDetails.roleName}</p>
            </div>
            <div>
                {(agencyDetails.roleName === 'Admin' || agencyDetails.roleName === 'Manager') && (
                    <button className={styles.actionButton} onClick={() => setShowInviteDialog(true)}>Invite Users</button>
                )}
                {(agencyDetails.roleName === 'Admin' || agencyDetails.roleName === 'Manager') && (
                    <button className={styles.actionButton} onClick={() => setShowRemoveUserDialog(true)}>Remove Users</button>
                )}
            </div>
            {showInviteDialog && (
                <div className="modal-backdrop">
                    <div className="modal-content">
                        <h3>Invite Users to {agencyDetails.companyName}</h3>
                        <InvitationForm
                            onSubmit={(email, role) => handleInvite(email, role)}
                            onCancel={() => setShowInviteDialog(false)}
                        />
                    </div>
                </div>
            )}
            {showRemoveUserDialog && (
                <div className="modal-backdrop">
                    <div className="modal-content">
                        <h3>Remove Users from {agencyDetails.companyName}</h3>
                        <RemoveUserForm
                            users={agencyUsers
                                .map(u => ({ ...u.user, _id: u.user.id }))
                                .filter(u => u.id !== userDetails.id)
                            } // Map to expected structure and exclude current user
                            onRemove={handleRemoveUsers}
                            onCancel={() => setShowRemoveUserDialog(false)}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ManageAgency;
